import { contactParams, normalizeCollectionResponse } from 'api';
import { client, computeHeaders } from 'queries';

export const contactsQuery = async ({ req, params }) => {
	const formattedParams = {
		...contactParams,
		page: 0,
		pageSize: 6,
		sortProp: 'createdAt',
		sortValue: 'asc',
		include: [],
		context: ['ssr'],
	};
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: '/contacts', headers, params: formattedParams });
	return normalizeCollectionResponse(response);
};
